// **************************************************
// Accordion toggle
// **************************************************
function closeAccordions() {
  const openAccordions = document.querySelectorAll('.accordion__item.is-open');
  openAccordions.forEach((openAccordion) => {
    const openContent = openAccordion.querySelector('.accordion__item-content');
    openAccordion.classList.remove('is-open');
    slideUp(openContent, 300);
  });
}

const accordionTitles = document.querySelectorAll('.accordion__item-title');
accordionTitles.forEach((accordionTitle) => {
  const accordionItem = accordionTitle.closest('.accordion__item');
  const accordionContent = accordionItem.querySelector('.accordion__item-content');

  accordionTitle.addEventListener('click', () => {
    if (accordionItem.classList.contains('is-open')) {
      closeAccordions();
    } else {
      closeAccordions();
      accordionItem.classList.add('is-open');
      slideDown(accordionContent, 300, 'block');
    }
  });
});
